<template>
  <div class="flex items-center gap-2 text-sm">
    <VTooltip
      :disabled="!showTooltip"
      :text="`${person.firstName} ${person.lastName}`"
      :location="'top center'"
      :offset="0"
    >
      <template #activator="{ props }">
        <PersonAvatar
          v-bind="props"
          :class="'ring-2 ring-white'"
          :first-name="person.firstName ?? ''"
          :last-name="person.lastName ?? ''"
          :size="avatarSize"
          :type="isUser(person) ? 'physician' : 'patient'"
        />
      </template>
    </VTooltip>

    <p class="text-sm font-semibold" data-testid="person-details">
      <span v-if="isUser(person)">{{ `${person.title ?? ''} ` }}</span>
      <span>{{ `${person.firstName} ` }}</span>
      <span>{{ person.lastName }}</span>
    </p>
  </div>
</template>

<script setup lang="ts">
import PersonAvatar from '@/components/navigation/PersonAvatar.vue'
import type { PatientDTO, UserDTO } from '@/generated'

interface Props {
  person: UserDTO | PatientDTO
  avatarSize?: number
  showTooltip?: boolean
}

defineProps<Props>()

function isUser(person: UserDTO | PatientDTO): person is UserDTO {
  return 'userName' in person
}
</script>

<style scoped></style>
